module.exports = __webpack_public_path__ + "static/img/file_vue.1f3fc106.png";